import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSearchContext } from '../../hooks/useSearch';
import usePageNavigation from '../../hooks/usePageNavigation';
import {
  DropdownNavWrapper,
  StyledDropdownNav,
  Dropdown,
  DropdownTitle,
  SelectedItem,
  Option
} from './styled';

const DropdownNav = ({ questions, scrollOffset = 0, color, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const { debouncedSearch } = useSearchContext();

  const handleClick = (e) => {
    // close dropdown if user clicks outside of it
    if (dropdownRef?.current?.contains(e.target)) return;
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const { activeLinkIndex, createClickHandler } = usePageNavigation(
    questions,
    scrollOffset
  );

  if (debouncedSearch) {
    return <div />;
  }

  return (
    <DropdownNavWrapper {...props}>
      <StyledDropdownNav ref={dropdownRef}>
        <SelectedItem onClick={() => setIsOpen(true)} isOpen={isOpen} $color={color}>
          {questions[activeLinkIndex]?.fields.question}
        </SelectedItem>
        <Dropdown isOpen={isOpen} $color={color}>
          <DropdownTitle onClick={() => setIsOpen(false)} $color={color}>
            {questions[activeLinkIndex]?.fields.question}
          </DropdownTitle>
          {questions.map((question, i) => (
            <Option
              key={i}
              href={`#${question.sys.id}`}
              active={i === activeLinkIndex}
              $color={color}
              onClick={(e) => {
                createClickHandler(`question-${question.sys.id}`)(e);
                setIsOpen(false);
              }}
            >
              {question.fields.question}
            </Option>
          ))}
        </Dropdown>
      </StyledDropdownNav>
    </DropdownNavWrapper>
  );
};

DropdownNav.propTypes = {
  className: PropTypes.string,
  questions: PropTypes.array,
  scrollOffset: PropTypes.number,
  color: PropTypes.string
};

export default DropdownNav;
